module.exports = __webpack_public_path__ + "static/media/25-11.2b381465.mp3";